import { FC } from "react";
import {
  i18translateType,
  PagePropsBasicType,
} from "../../../@types/types-body";
import { useTranslation } from "next-i18next";

const CareerSection: FC<PagePropsBasicType> = ({ namespace }) => {
  const { t }: i18translateType = useTranslation(namespace);
  return (
    <section>
      <div className={"container"}>
        <h1 className="text:lg md:text-5xl text-center font-extrabold">
          {t("title")}
        </h1>
        <div className="grid grid-cols-12 grid-flow-row-dense md:grid-flow-col-dense md:gap-x-12 md:content-between">
          <div className="col-span-12 md:col-span-6 text-justify py-14">
            <h1 className="text:2xl md:text-3xl font-bold">
              {t("card_left.title")}
            </h1>
            <p className={"my-4 text-justify text-base"}>
              {t("card_left.paragraph")}
            </p>
          </div>
          <div className="col-span-12 md:col-span-6 mb-8 lg:mb-0 md:place-self-end">
            <p className={"my-4 text-justify text-base"}>
              {t("card_right.text_one")}
            </p>
            <p className={"my-4 text-justify text-base"}>
              {t("card_right.text_two")}
            </p>
            <p className={"my-4 text-justify text-base"}>
              {t("card_right.text_three")}
            </p>
          </div>
        </div>
        <h1 className="text:lg md:text-5xl text-center font-extrabold mt-28 my-40">
          {t("open_positions")}
        </h1>
      </div>
    </section>
  );
};

export default CareerSection;
